export default {
  /**
   * COUPON_V3 按钮跳转类型枚举
   * 
   * - TMD_WITHDRAW: 天美贷我要提现
   * - TMD_CREDIT_APPLY: 天美贷授信申请
   * - CREDIT_APPLY: 授信申请
   * - LOAN_APPLY: 放款申请
   
   * - TMD_MY_COUPON_PACKAGE: 天美贷我的券包
   * - TMD_REPAYMENT_LIST: 天美贷还款列表
   * - MY_PAY_BILL: 我的账单页面
   * - COUPON_LIST: 券包
   * - PROVIDE_DETAIL: 券详情
   * 
  */
  mounted () {
    const { skipType, couponSerialNo, cacheCouponSerialNo } = this.$route.query
    sessionStorage.removeItem('couponSerialNoV3')
    if (cacheCouponSerialNo === 'Y' && couponSerialNo) {
      sessionStorage.setItem('couponSerialNoV3', couponSerialNo)
    }
    if (['CREDIT_APPLY', 'LOAN_APPLY', 'TMD_WITHDRAW', 'TMD_CREDIT_APPLY'].includes(skipType)) {
      return this.$router.replace({
        path: '/middle/limit'
      })
    }
    if (['COUPON_LIST', 'TMD_MY_COUPON_PACKAGE'].includes(skipType)) {
      return this.$router.replace({
        path: '/quan/list'
      })
    }

    if (['MY_PAY_BILL'].includes(skipType)) {
      return this.$router.replace('/repayment/history')
    }
      
    if (['TMD_REPAYMENT_LIST'].includes(skipType)) {
      return this.$router.replace('/repayment')
    }

    if (skipType === 'PROVIDE_DETAIL') {
      return this.$router.replace({
        path: '/quan/detail',
        query: {
          couponRecordId: couponSerialNo
        }
      })
    }
    this.$bus.$emit('ready')
  },

  render () {
    return <div />
  }
}
